import { Row, Col, Flex, Button, Image, Typography } from "antd";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { useState, useEffect, useContext } from "react";
import { IndexContext } from "../../context/IndexContext";
import Decimal from "decimal.js";
import * as _ from "@antv/util";

const PRICE_SELECTION = [0.1, 0.5, 1.0];

export default function CorrectionTab(props) {
  const {
    selectedItemKey,
    setSelectedItemKey,
    plates,
    setPlates,
    selectedPlateIndex,
    category,
    selectedSubCategory,
    setSelectedSubCategory,
  } = props;

  const { isLightTheme } = useContext(IndexContext);

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subCategory, setSubCategory] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editType, setEditType] = useState();

  const onQuantityButtonClicked = () => {
    setIsEditModalOpen(true);
    setEditType("quantity");
  };

  const onPriceButtonClicked = () => {
    setIsEditModalOpen(true);
    setEditType("unit_price");
  };

  function onCategoryButtonClicked(cat) {
    setSelectedCategory(cat.label);
    setSelectedSubCategory(cat.default_child_category_name);
    let cloned_plates = JSON.parse(JSON.stringify(plates));
    let new_item_key = _.uniqueId("item-");

    if (cat.default_child_category_id) {
      cloned_plates[selectedPlateIndex].items.push({
        key: new_item_key,
        category_id: cat.default_child_category_id,
        category: cat.label,
        sub_category: cat.default_child_category_name,
        unit_price: cat.default_child_unit_price,
        quantity: 1,
      });
    } else {
      cloned_plates[selectedPlateIndex].items.push({
        key: new_item_key,
        category_id: cat.id,
        category: cat.label,
        sub_category: "",
        unit_price: cat.unit_price,
        quantity: 1,
      });
    }

    setPlates(cloned_plates);
    setSelectedItemKey(new_item_key);
  }

  function onSubCatButtonClicked(cat) {
    if (selectedItemKey) {
      let cloned_plates = JSON.parse(JSON.stringify(plates));
      let item_index = cloned_plates[selectedPlateIndex].items.findIndex(
        (item) => item.key === selectedItemKey
      );

      cloned_plates[selectedPlateIndex].items[item_index].category_id = cat.id;
      cloned_plates[selectedPlateIndex].items[item_index].category =
        selectedCategory;
      cloned_plates[selectedPlateIndex].items[item_index].sub_category =
        cat.label;
      cloned_plates[selectedPlateIndex].items[item_index].unit_price =
        cat.unit_price;

      setPlates(cloned_plates);
      setSelectedSubCategory(cat.label);
    }
  }

  function onMinusButtonClicked(price) {
    if (selectedItemKey) {
      let cloned_plates = JSON.parse(JSON.stringify(plates));
      let item_index = cloned_plates[selectedPlateIndex].items.findIndex(
        (item) => item.key === selectedItemKey
      );
      let current = new Decimal(
        cloned_plates[selectedPlateIndex].items[item_index].unit_price
      );
      let value = new Decimal(price);

      cloned_plates[selectedPlateIndex].items[item_index].unit_price = current
        .minus(value)
        .toNumber();

      if (cloned_plates[selectedPlateIndex].items[item_index].unit_price >= 0) {
        setPlates(cloned_plates);
      }
    }
  }

  function onPlusButtonClicked(price) {
    if (selectedItemKey) {
      let cloned_plates = JSON.parse(JSON.stringify(plates));
      let item_index = cloned_plates[selectedPlateIndex].items.findIndex(
        (item) => item.key === selectedItemKey
      );
      let current = new Decimal(
        cloned_plates[selectedPlateIndex].items[item_index].unit_price
      );
      let value = new Decimal(price);

      cloned_plates[selectedPlateIndex].items[item_index].unit_price = current
        .plus(value)
        .toNumber();

      setPlates(cloned_plates);
    }
  }

  function onMinusQuantityButtonClicked() {
    if (selectedItemKey) {
      let cloned_plates = JSON.parse(JSON.stringify(plates));
      let item_index = cloned_plates[selectedPlateIndex].items.findIndex(
        (item) => item.key === selectedItemKey
      );
      let current =
        cloned_plates[selectedPlateIndex].items[item_index].quantity;

      cloned_plates[selectedPlateIndex].items[item_index].quantity =
        current - 1;

      if (cloned_plates[selectedPlateIndex].items[item_index].quantity >= 1) {
        setPlates(cloned_plates);
      }
    }
  }

  function onPlusQuantityButtonClicked() {
    if (selectedItemKey) {
      let cloned_plates = JSON.parse(JSON.stringify(plates));
      let item_index = cloned_plates[selectedPlateIndex].items.findIndex(
        (item) => item.key === selectedItemKey
      );
      let current =
        cloned_plates[selectedPlateIndex].items[item_index].quantity;

      cloned_plates[selectedPlateIndex].items[item_index].quantity =
        current + 1;

      setPlates(cloned_plates);
    }
  }

  useEffect(() => {
    setSelectedCategory((prevSelectedCategory) => {
      if (selectedItemKey) {
        let new_selected_category = plates[selectedPlateIndex].items.filter(
          (item) => item.key === selectedItemKey
        )[0]?.category;

        if (
          prevSelectedCategory &&
          prevSelectedCategory != new_selected_category
        ) {
          document.getElementById(prevSelectedCategory).style.borderColor =
            "#d9d9d9";
        }
        return new_selected_category;
      } else {
        if (prevSelectedCategory) {
          document.getElementById(prevSelectedCategory).style.borderColor =
            "#d9d9d9";
        }
        return null;
      }
    });
  }, [selectedItemKey]);

  useEffect(() => {
    if (selectedCategory) {
      document.getElementById(selectedCategory).style.borderColor = "#4096ff";
      document.getElementById(selectedCategory).scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
      setSubCategory(
        category.filter((cat) => cat.label === selectedCategory)[0]?.children
      );
    } else {
      setSubCategory([]);
    }
  }, [selectedCategory]);

  return (
    <Row gutter={[8, 0]} style={{ height: "100%", width: "100%" }}>
      <Col span={24} style={{ height: "calc(15% - 4px)" }}>
        <div className="cat-container" style={{ height: "100%" }}>
          {category
            .sort((a, b) => {
              if (a.sequence === null && b.sequence === null) return 0; // Both are null
              if (a.sequence === null) return 1; // `a` is null, so it comes after
              if (b.sequence === null) return -1; // `b` is null, so it comes after
              return a.sequence - b.sequence; // Compare numerically
            })
            .map((cat, index) => {
              return (
                <Button
                  key={index}
                  id={cat.label}
                  className="cat-btn"
                  onClick={() => {
                    if (selectedCategory && selectedCategory != cat.label) {
                      document.getElementById(
                        selectedCategory
                      ).style.borderColor = "#d9d9d9";
                    }
                    onCategoryButtonClicked(cat);
                  }}
                  disabled={plates.length == 0}
                >
                  <div
                    className={
                      selectedCategory == cat.label
                        ? "select-cat-image-container"
                        : "cat-image-container"
                    }
                  >
                    <img
                      className={
                        selectedCategory == cat.label
                          ? "select-cat-image"
                          : "cat-image"
                      }
                      src={cat.image}
                    />
                  </div>
                </Button>
              );
            })}
        </div>
      </Col>
      <Col span={24} style={{ height: "calc(85% - 4px)" }}>
        <Row gutter={[8, 0]} style={{ height: "100%", width: "100%" }}>
          <Col span={16} style={{ height: "100%" }}>
            <div className="sub-cat-container">
              {subCategory
                .sort((a, b) => {
                  if (a.sequence === null && b.sequence === null) return 0; // Both are null
                  if (a.sequence === null) return 1; // `a` is null, so it comes after
                  if (b.sequence === null) return -1; // `b` is null, so it comes after
                  return a.sequence - b.sequence; // Compare numerically
                })
                .map((cat) => {
                  return (
                    <div
                      className={
                        cat.label === selectedSubCategory
                          ? cat.is_common
                            ? "selected-common-sub-cat-btn"
                            : "selected-sub-cat-btn"
                          : cat.is_common
                          ? "common-sub-cat-btn"
                          : "sub-cat-btn"
                      }
                      onClick={() => {
                        onSubCatButtonClicked(cat);
                      }}
                    >
                      <span className="cat-label">{cat.label}</span>
                      <span className="unit-price">
                        RM {cat.unit_price.toFixed(2)}
                      </span>
                    </div>
                  );
                })}
            </div>
          </Col>
          <Col span={8} style={{ height: "100%" }}>
            <Flex
              justify="space-around"
              style={{ width: "100%", marginBottom: "10px" }}
            >
              <span style={{ fontWeight: "bold", fontSize: "24px" }}>
                {selectedCategory}
              </span>
            </Flex>
            {selectedCategory ? (
              <div
                style={{
                  width: "100%",
                  overflow: "auto",
                  whiteSpace: "nowrap",
                }}
              >
                <Flex
                  justify="space-around"
                  style={{
                    width: "100%",
                    marginBottom: "50px",
                  }}
                >
                  <Button
                    className="minus-btn"
                    icon={<MinusOutlined className="price-action-icon" />}
                    onClick={onMinusQuantityButtonClicked}
                  />
                  <div
                    className="quantity-tag"
                    style={{
                      borderColor: isLightTheme ? "black" : "white",
                      background: isLightTheme ? "#e7e6e6" : "#e7e6e634",
                    }}
                  >
                    {selectedItemKey
                      ? plates[selectedPlateIndex]?.items.filter(
                          (item) => item.key === selectedItemKey
                        )[0]?.quantity ?? 0
                      : 0}{" "}
                    Qty
                  </div>
                  <Button
                    className="plus-btn"
                    icon={<PlusOutlined className="price-action-icon" />}
                    onClick={onPlusQuantityButtonClicked}
                  />
                </Flex>
                {PRICE_SELECTION.map((price) => {
                  return (
                    <Flex
                      justify="space-around"
                      style={{ width: "100%", marginBottom: "5px" }}
                    >
                      <Button
                        className="minus-btn"
                        icon={<MinusOutlined className="price-action-icon" />}
                        onClick={() => {
                          onMinusButtonClicked(price);
                        }}
                      />
                      <div
                        className="price-tag"
                        style={{
                          borderColor: isLightTheme ? "black" : "white",
                        }}
                      >
                        RM {price.toFixed(2)}
                      </div>
                      <Button
                        className="plus-btn"
                        icon={<PlusOutlined className="price-action-icon" />}
                        onClick={() => {
                          onPlusButtonClicked(price);
                        }}
                      />
                    </Flex>
                  );
                })}
                {/* <Flex gap="small" style={{ marginTop: "10px" }}>
                  <Button
                    className="custom-btn"
                    type="primary"
                    onClick={onQuantityButtonClicked}
                    block
                  >
                    Quantity
                  </Button>
                  <Button
                    className="custom-btn"
                    type="primary"
                    onClick={onPriceButtonClicked}
                    block
                  >
                    Price
                  </Button>
                  <EditModal
                    isEditModalOpen={isEditModalOpen}
                    setIsEditModalOpen={setIsEditModalOpen}
                    editType={editType}
                    plates={plates}
                    setPlates={setPlates}
                    selectedPlateIndex={selectedPlateIndex}
                    selectedItemKey={selectedItemKey}
                  />
                </Flex> */}
              </div>
            ) : (
              <></>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
